import { render, staticRenderFns } from "./BrebCropper.vue?vue&type=template&id=08965794&scoped=true&"
import script from "./BrebCropper.vue?vue&type=script&lang=js&"
export * from "./BrebCropper.vue?vue&type=script&lang=js&"
import style0 from "./BrebCropper.vue?vue&type=style&index=0&id=08965794&prod&scoped=true&lang=css&"
import style1 from "./BrebCropper.vue?vue&type=style&index=1&id=08965794&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08965794",
  null
  
)

export default component.exports